var _a, _b, _c, _d, _e, _f, _g, _h;
import { __decorate, __metadata } from "tslib";
import { Component } from 'decorators';
import angular from 'angular';
import { v4 as uuid } from 'uuid';
import view from './aiOutputs.view.html';
import './aiOutputs.scss';
import { OutputAddNewState, OutputChange, OutputUpdateAndSaveState, } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/outputs/components/outputs/outputs.dispatcher';
import { BuilderFeatures } from 'modules/application/detail/portal-submodule-builder/templates/builder/BuilderFeatures';
import { BlipToastService } from 'modules/shared/BlipToastService';
import { ToastType } from 'modules/application/misc/ToastService';
import { AlertService } from 'modules/shared/AlertService';
import { UndoRedoService } from 'modules/application/misc/UndoRedoService';
import { BuilderSegmentService } from 'modules/application/detail/portal-submodule-builder/templates/builder/services/BuilderSegmentService';
import { CardOutputContentIAction } from 'modules/application/detail/portal-submodule-builder/templates/builder/historyActions';
import { OutputViewModel } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/viewModels/OutputViewModel';
import { BuilderStore } from 'modules/application/detail/portal-submodule-builder/templates/builder/store/BuilderStore';
import { Condition, ConditionComparison, ValueSource } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/Condition';
import { insertAtPosition } from 'modules/shared/helpers/Array';
import { immutableSplice } from 'data/array';
import { ActionType } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/Action';
import { variableCondition, variableConditionHandoff, variableValueHandoff } from 'modules/application/detail/portal-submodule-builder/templates/builder/aiAgent/state/Outputs';
import { BUILDER_AGENT_TARGETING_ADDED } from '../../../events';
import { AgentSegmentService } from '../../../services/AgentSegmentService';
import { convertHoursFormatToMinutes, convertMinutesToHoursFormat } from 'data/date';
import { ValidationHelper } from 'modules/application/detail/portal-submodule-builder/templates/helpers/ValidationHelper';
const builderStore = BuilderStore.getInstance();
let AiOutputs = class AiOutputs {
    static $inject = ['BuilderSegmentService', 'UndoRedoService', 'BlipToastService', 'clipboard', '$translate', 'AlertService', 'AgentSegmentService', '$timeout'];
    constructor(BuilderSegmentService, UndoRedoService, BlipToastService, clipboard, $translate, AlertService, AgentSegmentService, $timeout) {
        'ngInject';
        this.BuilderSegmentService = BuilderSegmentService;
        this.UndoRedoService = UndoRedoService;
        this.BlipToastService = BlipToastService;
        this.clipboard = clipboard;
        this.$translate = $translate;
        this.AlertService = AlertService;
        this.AgentSegmentService = AgentSegmentService;
        this.$timeout = $timeout;
        this.isStudioInactivityHandoffEnabled = false;
        this.isSwitchEnabled = false;
        this.isInactivityTimeValid = false;
        this.isRedirectOutputValid = false;
        this.inactivityErrorMessage = '';
        //#region Properties
        this.selectedOutputs = [];
        this.isBuilderUndoRedoOutputsEnabled = false;
        this.$onChanges = (changes) => {
            if (changes.states && !changes.states) {
                this.updateFilteredStates();
            }
        };
        this.updateFilteredStates = () => {
            if (!this.states) {
                throw new Error('The "states" object is undefined. Ensure that the component receives the correct states binding.');
            }
            if (this.state.id === undefined) {
                throw new Error('The "state.id" property is undefined. Ensure that the current state has a valid ID.');
            }
            this.filteredStates = angular.copy(this.states);
            delete this.filteredStates[this.state.id];
        };
        this.copyOutput = async (output) => {
            this.copyOutpus([output]);
        };
        this.copyMultipleSelected = async () => {
            this.copyOutpus(this.selectedOutputs);
        };
        this.copyOutpus = async (outputs) => {
            try {
                outputs = outputs.map((item) => {
                    const outputName = this.getOutputName(item);
                    const handoff = this.getHandoff(outputName);
                    return { ...item, $handoff: handoff };
                });
                const jsonStringOutput = JSON.stringify(outputs);
                this.clipboard.copyText(jsonStringOutput);
                this.BlipToastService.show(ToastType.Success, {
                    msg: await this.$translate('aiOutputs.toast.copySuccess'),
                    duration: 3000,
                });
                this.trackCopy();
            }
            catch (ex) {
                this.BlipToastService.show(ToastType.Danger, {
                    msg: await this.$translate('aiOutputs.toast.copyError'),
                    duration: 3000,
                });
            }
        };
        this.deleteMultipleSelected = async () => {
            try {
                if (this.selectedOutputs) {
                    this.selectedOutputs.forEach(async (output) => {
                        this.deleteOutputItem(output, 0);
                    });
                    this.validateTabAndSaveState();
                    this.selectedOutputs = [];
                    this.BlipToastService.show(ToastType.Success, {
                        msg: await this.$translate('aiOutputs.edit.toast.deleteSuccess'),
                        duration: 3000,
                    });
                }
            }
            catch (ex) {
                this.BlipToastService.show(ToastType.Danger, {
                    msg: await this.$translate('aiOutputs.edit.toast.deleteError'),
                    duration: 3000,
                });
            }
        };
        this.pasteOutput = async () => {
            if (!navigator.clipboard.readText) {
                return;
            }
            try {
                const copiedOutputs = await navigator.clipboard.readText();
                const outputs = JSON.parse(copiedOutputs);
                this.addOutputs(outputs);
            }
            catch (ex) {
                this.BlipToastService.show(ToastType.Danger, {
                    msg: await this.$translate('aiOutputs.pasteError'),
                    duration: 3000,
                });
            }
        };
        this.addOutputs = async (outputs) => {
            const outputsToProcess = Array.isArray(outputs) ? outputs : [outputs];
            try {
                if (outputs !== undefined) {
                    outputsToProcess.forEach(output => {
                        output.$id = uuid();
                        let newOutputName = this.getOutputName(output);
                        newOutputName = newOutputName + '_copy';
                        this.getOutputConditionUpdated(output, newOutputName);
                        this.state.$conditionOutputs.push(angular.copy(output));
                        if (output.$handoff) {
                            output.$handoff.name = newOutputName;
                            this.saveNewOuputHandoff(output.$handoff);
                        }
                        this.validateTabAndSaveState();
                    });
                    this.BlipToastService.show(ToastType.Success, {
                        msg: await this.$translate('aiOutputs.toast.pasteSuccess'),
                        duration: 3000,
                    });
                }
            }
            catch (ex) {
                this.BlipToastService.show(ToastType.Danger, {
                    msg: await this.$translate('aiOutputs.toast.pasteError'),
                    duration: 3000,
                });
            }
        };
        this.isSelected = ($index) => this.selectedOutputs?.some(out => out.$contentId == $index) ?? false;
        this.isAllOutputsSelected = () => this.state.$conditionOutputs
            .filter(out => out.$isAgentOutput &&
            out.$isAgentCustomOutput &&
            !out.$isAgentDefaultOutput).length > 0 &&
            this.selectedOutputs.length === this.state.$conditionOutputs.length - 1 ? true : false;
        this.selectAll = (event) => {
            if (event.detail.checked) {
                this.selectedOutputs = this.state.$conditionOutputs.map((item, index) => {
                    return { ...item, $contentId: String(index) };
                }).filter(out => out.$isAgentOutput && out.$isAgentCustomOutput && !out.$isAgentDefaultOutput);
            }
            else {
                this.selectedOutputs = [];
            }
            this.trackAllSelected();
        };
        this.selectOutput = (event) => {
            const index = event.target.id;
            const outputSelected = this.state.$conditionOutputs[index];
            if (outputSelected !== undefined) {
                const outputs = this.selectedOutputs.filter(out => out.$contentId == index);
                if (outputs.length === 0) {
                    this.selectedOutputs.push({ ...angular.copy(outputSelected), $contentId: index });
                }
                else {
                    this.selectedOutputs = this.selectedOutputs.filter(out => out.$contentId != index);
                }
                this.trackSelected();
            }
        };
        this.onSwitchInactivityRedirection = async (event) => {
            const isEnabled = event.detail.checked;
            this.isSwitchEnabled = isEnabled;
            this.isInactivityTimeValid = false;
            this.isRedirectOutputValid = false;
            if (!isEnabled) {
                this.clearInactivityOutputSelection();
                this.removeExpirationFromInputAction();
                this.inactivityErrorMessage = '';
                this.setDangerAttribute('inactivity-time-input', false);
                this.setErrorAttribute('inactivity-time-input', this.inactivityErrorMessage);
                return;
            }
            this.onChangeInactivityTime({ detail: { value: String(this.getInactivityTimeFromExpiration() || '') } });
        };
        this.onChangeInactivityTime = async (event) => {
            if (!this.isSwitchEnabled) {
                this.setDangerAttribute('inactivity-time-input', false);
                this.setErrorAttribute('inactivity-time-input', this.inactivityErrorMessage);
                return;
            }
            const contentActionInput = this.getContentActionInput();
            this.inactivityErrorMessage = await ValidationHelper.validateNumericRange(event.detail.value, 1, 1380, this.$translate, {
                empty: 'aiOutputs.inactivity.errors.inputIsEmpty',
                notNumber: 'aiOutputs.inactivity.errors.inputIsNotANumber',
                decimal: 'aiOutputs.inactivity.errors.inputIsDecimal',
                outOfRange: 'aiOutputs.inactivity.errors.timeLimitRange',
            });
            const isValid = this.inactivityErrorMessage === '';
            this.isInactivityTimeValid = isValid;
            contentActionInput.$invalid = !isValid;
            if (isValid) {
                this.setDangerAttribute('inactivity-time-input', false);
                this.setErrorAttribute('inactivity-time-input', this.inactivityErrorMessage);
                const inactivityTime = parseInt(event.detail.value, 10);
                this.updateInactivityExpiration(contentActionInput, inactivityTime);
                const currentState = angular.copy(this.state);
                builderStore.setState({ ...currentState });
                this.validateTabAndSaveState();
            }
            else {
                this.setDangerAttribute('inactivity-time-input', true);
                this.setErrorAttribute('inactivity-time-input', this.inactivityErrorMessage);
            }
        };
        this.onChangeInactivityRedirectOutput = async ($data) => {
            if (!this.isSwitchEnabled) {
                return;
            }
            await this.addOrUpdateInactivityOutput($data.newTarget);
            const inactivityOutputStateId = this.getInactivityOutputStateId();
            const isValid = inactivityOutputStateId !== '';
            this.isRedirectOutputValid = isValid;
            if (this.isBuilderUndoRedoOutputsEnabled) {
                this.UndoRedoService.add(this.changeInactivityOutputUndoRedoAction($data.newTarget, $data.oldTarget, $data.newTypeOfStateId, $data.oldTypeOfStateId));
            }
            const currentState = angular.copy(this.state);
            builderStore.setState({ ...currentState });
            this.validateTabAndSaveState();
        };
        this.getInactivityTimeFromExpiration = () => {
            const inputAction = this.getContentActionInput();
            const existingExpiration = inputAction?.input?.expiration;
            if (existingExpiration?.includes(':')) {
                const totalMinutes = convertHoursFormatToMinutes(existingExpiration);
                if (totalMinutes > 0 && totalMinutes <= 1380) {
                    return totalMinutes;
                }
            }
            return null;
        };
        this.getInactivityOutputStateId = () => {
            const inactivityOutput = this.state.$conditionOutputs.find(output => output.$isAgentInactivityOutput === true);
            return inactivityOutput?.stateId || '';
        };
        this.getInactivityOutput = () => {
            return this.state.$conditionOutputs.find(co => co.$isAgentOutput && co.$isAgentInactivityOutput);
        };
        this.checkIfInactivityTimeIsValid = () => {
            const contentActionInput = this.getContentActionInput();
            if (contentActionInput?.input?.expiration === undefined) {
                return false;
            }
            const inactivityTime = convertHoursFormatToMinutes(contentActionInput?.input?.expiration);
            return inactivityTime &&
                !isNaN(inactivityTime) &&
                inactivityTime > 0 &&
                inactivityTime <= 1380;
        };
        this.checkIfRedirectOutputIsValid = () => {
            const inactivityOutputStateId = this.getInactivityOutputStateId();
            return inactivityOutputStateId !== '';
        };
        this.clearInactivityOutputSelection = () => {
            const inactivityOutputIndex = this.getInactivityOutputIndex();
            if (inactivityOutputIndex !== -1) {
                this.state.$conditionOutputs.splice(inactivityOutputIndex, 1);
                const currentState = angular.copy(this.state);
                builderStore.setState({ ...currentState });
                this.validateTabAndSaveState();
            }
        };
        this.removeExpirationFromInputAction = () => {
            const inputAction = this.getContentActionInput();
            if (inputAction?.input?.expiration) {
                delete inputAction.input.expiration;
            }
            const currentState = angular.copy(this.state);
            builderStore.setState({ ...currentState });
            this.validateTabAndSaveState();
        };
        this.updateInactivityExpiration = (inputAction, minutes) => {
            if (inputAction?.input) {
                inputAction.input.expiration = convertMinutesToHoursFormat(minutes);
            }
        };
        this.getInactivityOutputIndex = () => {
            return this.state.$conditionOutputs.findIndex(co => co.$isAgentOutput && co.$isAgentInactivityOutput);
        };
        this.getContentActionInput = () => {
            return this.state.$contentActions?.find(action => action.input);
        };
    }
    //#endregion
    //#region Lifecycle Hooks
    async $onInit() {
        this.oldState = angular.copy(this.state);
        this.forwardSettings = this.state.$enteringCustomActions.find(action => action.type === ActionType.ForwardToAgent)?.settings;
        this.fillSortableOptions();
        setTimeout(() => this.validateTab());
        await this.checkFeatures();
        this.updateFilteredStates();
        this.isStudioInactivityHandoffEnabled = await BuilderFeatures.isStudioInactivityHandoffEnabled();
        this.isInactivityTimeValid = this.checkIfInactivityTimeIsValid();
        this.isRedirectOutputValid = this.checkIfRedirectOutputIsValid();
        this.isSwitchEnabled = this.isInactivityTimeValid || this.isRedirectOutputValid;
    }
    async $dispatch($action) {
        if (this.onAction) {
            this.onAction({ $action });
        }
    }
    //#endregion
    //#region Methods
    async checkFeatures() {
        this.isBuilderUndoRedoOutputsEnabled = await BuilderFeatures.builderUndoRedoOutputsEnabled();
    }
    fillSortableOptions() {
        this.ngSortableOptions = {
            animation: 0,
            scroll: true,
            handle: '.anchor',
            disabled: false,
            onSort: (e) => {
                const cardContentIAction = new CardOutputContentIAction({
                    data: {
                        state: {
                            id: angular.copy(this.state.id),
                            $title: angular.copy(this.state.$title),
                        },
                        output: angular.copy(this.state.$conditionOutputs[e?.oldIndex]),
                        oldIndex: e?.oldIndex,
                        newIndex: e?.newIndex,
                        currentModels: e?.models,
                    },
                    execute: (data) => {
                        const currentState = this.state;
                        builderStore.setState({
                            ...currentState,
                            $conditionOutputs: data.currentModels,
                        });
                    },
                    undo: (data) => {
                        data.currentModels = angular.copy(this.state.$conditionOutputs);
                        this.swapContentsPosition(data.newIndex, data.oldIndex);
                    },
                });
                if (this.isBuilderUndoRedoOutputsEnabled) {
                    this.UndoRedoService.add(cardContentIAction);
                }
                this.onUpdateAndSaveState();
                this.trackBlockOutputConditionsPositionChanged();
            },
        };
    }
    swapContentsPosition(firstContentIndex, secondContentIndex) {
        const firstContent = angular.copy(this.state.$conditionOutputs[firstContentIndex]);
        const secondContent = angular.copy(this.state.$conditionOutputs[secondContentIndex]);
        const currentEditingConditions = angular.copy(this.state.$conditionOutputs);
        currentEditingConditions[firstContentIndex] = secondContent;
        currentEditingConditions[secondContentIndex] = firstContent;
        const currentState = this.state;
        builderStore.setState({
            ...currentState,
            $conditionOutputs: currentEditingConditions,
        });
    }
    onUpdateAndSaveState() {
        const action = new OutputUpdateAndSaveState();
        this.$dispatch(action);
        this.oldState = angular.copy(this.state);
    }
    validateTabAndSaveState() {
        this.onUpdateAndSaveState();
        this.validateTab();
    }
    getOutputName(output) {
        return output.conditions.filter(cond => cond.variable === variableCondition &&
            cond.source === ValueSource.Context &&
            cond.comparison === ConditionComparison.Equals)[0]?.values[0];
    }
    getOutputConditionUpdated(output, newValue) {
        const condition = output.conditions.filter(cond => cond.variable === variableCondition &&
            cond.source === ValueSource.Context &&
            cond.comparison === ConditionComparison.Equals)[0];
        if (condition && condition?.values[0]) {
            condition.values[0] = newValue;
        }
        return condition;
    }
    validateTab() {
        const outputsTabElement = document.getElementById('content-tab-1');
        if (outputsTabElement) {
            if (this.state.$invalidOutputs) {
                outputsTabElement.classList.add('invalid-background');
            }
            else {
                outputsTabElement.classList.remove('invalid-background');
            }
        }
    }
    removeOutputUndoRedoAction(output, index) {
        return new CardOutputContentIAction({
            data: {
                state: {
                    id: angular.copy(this.state.id),
                    $title: angular.copy(this.state.$title),
                },
                index: index,
                oldOutputs: angular.copy(this.oldState.$conditionOutputs),
                newOutputs: angular.copy(this.state.$conditionOutputs),
            },
            execute: (data) => {
                const currentState = builderStore.getState(data.state.id);
                this.oldState.$conditionOutputs = data.newOutputs;
                currentState.$conditionOutputs = immutableSplice(currentState.$conditionOutputs, data.index, 1);
                builderStore.setState({ ...currentState });
                this.validateTab();
                this.trackBlockOutputConditionDeleted();
            },
            undo: (data) => {
                const currentState = builderStore.getState(data.state.id);
                const newState = {
                    ...currentState,
                    $conditionOutputs: data.newOutputs,
                };
                builderStore.setState(newState);
                this.validateTab();
                this.trackBlockOutputConditionAdded();
            },
        });
    }
    async confirmDeleteOutput(index) {
        await this.AlertService.show({
            title: await this.$translate('aiOutputs.edit.alertDelete.title'),
            body: await this.$translate('aiOutputs.edit.alertDelete.body'),
            variant: 'delete',
            icon: 'trash',
            buttons: {
                cancel: await this.$translate('aiOutputs.edit.alertDelete.cancel'),
                confirm: await this.$translate('aiOutputs.edit.alertDelete.confirm'),
            },
            callback: {
                cancelButtonAction: () => { },
                confirmButtonAction: async () => { this.deleteOutput(index); },
            },
        });
    }
    async deleteOutput(index) {
        try {
            const output = this.state.$conditionOutputs[index];
            this.deleteOutputItem(output, index);
            this.validateTabAndSaveState();
            this.trackBlockOutputConditionDeleted();
            this.BlipToastService.show(ToastType.Success, {
                msg: await this.$translate('aiOutputs.edit.toast.deleteSuccess'),
                duration: 3000,
            });
        }
        catch (ex) {
            this.BlipToastService.show(ToastType.Danger, {
                msg: await this.$translate('aiOutputs.edit.toast.deleteError'),
                duration: 3000,
            });
        }
    }
    async deleteOutputItem(output, index) {
        const action = new OutputChange({
            state: this.state,
            output: output,
            newTarget: output.stateId,
        });
        if (this.isBuilderUndoRedoOutputsEnabled) {
            this.UndoRedoService.add(this.removeOutputUndoRedoAction(output, index));
        }
        const outputName = this.getOutputName(output);
        this.removeOuputHandoff(outputName);
        this.$timeout(async () => {
            await this.$dispatch(action);
        });
    }
    removeOuputHandoff(name) {
        if (this.forwardSettings) {
            const handoffList = this.forwardSettings?.handoffs?.filter(handoff => handoff.name !== name) ?? [];
            this.forwardSettings.handoffs = handoffList;
        }
    }
    async confirmDeleteMultipleSelected() {
        await this.AlertService.show({
            title: await this.$translate('aiOutputs.edit.alertDelete.title'),
            body: await this.$translate('aiOutputs.edit.alertDelete.body'),
            variant: 'delete',
            icon: 'trash',
            buttons: {
                cancel: await this.$translate('aiOutputs.edit.alertDelete.cancel'),
                confirm: await this.$translate('aiOutputs.edit.alertDelete.confirm'),
            },
            callback: {
                cancelButtonAction: () => { },
                confirmButtonAction: async () => { this.deleteMultipleSelected(); },
            },
        });
    }
    saveNewOuputHandoff(handoff) {
        if (this.forwardSettings) {
            const handoffList = this.forwardSettings?.handoffs ?? [];
            this.forwardSettings.handoffs = [...handoffList, handoff];
        }
    }
    addForwardOutput() {
        const output = OutputViewModel.create();
        output.$isAgentOutput = true;
        output.$isAgentCustomOutput = true;
        output.$isAgentDefaultOutput = false;
        output.conditions = [
            new Condition({
                source: ValueSource.Context,
                variable: variableConditionHandoff,
                comparison: ConditionComparison.Equals,
                values: [variableValueHandoff],
            }),
            new Condition({
                source: ValueSource.Context,
                variable: variableCondition,
                comparison: ConditionComparison.Equals,
                values: [],
            }),
        ];
        this.addOutput(output);
        this.AgentSegmentService.trackAiAgentBlock(BUILDER_AGENT_TARGETING_ADDED);
        this.onOpenDetail(output, this.state.$conditionOutputs.length - 1);
    }
    async addOrUpdateInactivityOutput(stateId) {
        const inactivityOutputIndex = this.getInactivityOutputIndex();
        if (inactivityOutputIndex !== -1) {
            this.state.$conditionOutputs[inactivityOutputIndex].stateId = stateId;
        }
        else {
            const notExistsOutput = OutputViewModel.create(stateId);
            notExistsOutput.$isAgentOutput = true;
            notExistsOutput.$isAgentCustomOutput = false;
            notExistsOutput.$isAgentDefaultOutput = false;
            notExistsOutput.$isAgentInactivityOutput = true;
            notExistsOutput.conditions = [
                new Condition({
                    source: ValueSource.Input,
                    comparison: ConditionComparison.NotExists,
                    values: [],
                }),
            ];
            notExistsOutput.$invalid = false;
            this.addOutput(notExistsOutput);
        }
    }
    addOutput(output) {
        this.state.$conditionOutputs = this.state.$conditionOutputs.concat(output);
        const currentState = angular.copy(this.state);
        builderStore.setState({ ...currentState });
        if (this.isBuilderUndoRedoOutputsEnabled) {
            this.UndoRedoService.add(this.createOutputUndoRedoAction(output));
        }
        this.validateTab();
        this.trackBlockOutputConditionAdded();
    }
    createOutputUndoRedoAction(output) {
        const outputIndex = this.state.$conditionOutputs.map((co) => co.$id).indexOf(output.$id);
        return new CardOutputContentIAction({
            data: {
                state: {
                    id: angular.copy(this.state.id),
                    $title: angular.copy(this.state.$title),
                },
            },
            execute: (data) => {
                const currentEditingState = angular.copy(this.state);
                const currentConditionalOutputs = builderStore.getState(data.state.id).$conditionOutputs;
                const newState = {
                    ...currentEditingState,
                    $conditionOutputs: insertAtPosition(currentConditionalOutputs, output, outputIndex),
                };
                builderStore.setState(newState);
                this.oldState.$conditionOutputs = angular.copy(this.state.$conditionOutputs);
                this.validateTab();
                this.trackBlockOutputConditionAdded();
            },
            undo: (data) => {
                const state = builderStore.getState(data.state.id);
                const newState = {
                    ...state,
                    $conditionOutputs: immutableSplice(state.$conditionOutputs, outputIndex, 1),
                };
                builderStore.setState(newState);
                this.validateTab();
                this.trackBlockOutputConditionDeleted();
            },
        });
    }
    getHandoff(outputValue) {
        return this.forwardSettings?.handoffs?.find(handoff => handoff.name === outputValue);
    }
    onOpenDetail($output, $index) {
        if (this.lock) {
            return;
        }
        this.onOpenAiOutputEditModal?.({ $output, $index });
    }
    changeDefaultOutputUndoRedoAction(newTarget, oldTarget, newTypeOfStateId, oldTypeOfStateId) {
        return new CardOutputContentIAction({
            data: {
                state: {
                    id: angular.copy(this.state.id),
                    $title: angular.copy(this.state.$title),
                },
                defaultOutput: oldTarget,
                newDefaultTarget: newTarget,
                newTypeOfStateId,
                oldTypeOfStateId,
            },
            execute: (data) => {
                const defaultOutputIndex = this.state.$conditionOutputs.findIndex((co) => co.$isAgentDefaultOutput);
                this.state.$conditionOutputs[defaultOutputIndex].typeOfStateId = data.newTypeOfStateId;
                this.state.$conditionOutputs[defaultOutputIndex].stateId = data.newDefaultTarget;
                const currentState = angular.copy(this.state);
                builderStore.setState({
                    ...currentState,
                });
            },
            undo: (data) => {
                const defaultOutputIndex = this.state.$conditionOutputs.findIndex((co) => co.$isAgentDefaultOutput);
                this.state.$conditionOutputs[defaultOutputIndex].typeOfStateId = data.oldTypeOfStateId;
                this.state.$conditionOutputs[defaultOutputIndex].stateId = data.defaultOutput;
                const currentState = angular.copy(this.state);
                builderStore.setState({
                    ...currentState,
                });
            },
        });
    }
    async changeDefaultOutput({ newTarget, oldTarget, newTypeOfStateId, oldTypeOfStateId }) {
        if (this.isBuilderUndoRedoOutputsEnabled) {
            this.UndoRedoService.add(this.changeDefaultOutputUndoRedoAction(newTarget, oldTarget, newTypeOfStateId, oldTypeOfStateId));
        }
        const defaultOutputIndex = this.state.$conditionOutputs.findIndex((co) => co.$isAgentDefaultOutput);
        this.state.$conditionOutputs[defaultOutputIndex].typeOfStateId = newTypeOfStateId;
        this.state.$conditionOutputs[defaultOutputIndex].stateId = newTarget;
        const currentState = angular.copy(this.state);
        builderStore.setState({
            ...currentState,
        });
        this.trackBlockOutputDefaultConditionEdited(newTarget, oldTarget);
    }
    async addNewState({ output, state, label, oldTarget }) {
        const defaultOutput = this.state.$conditionOutputs.find(out => out.$isAgentDefaultOutput);
        const action = new OutputAddNewState({
            output: defaultOutput,
            state: this.state,
            newTarget: label,
            oldTarget,
        });
        await this.$dispatch(action);
        this.validateTabAndSaveState();
    }
    // Segment
    trackBlockOutputConditionAdded() {
        this.BuilderSegmentService.trackBlockOutputConditionAdded({
            NumberConditions: this.state.$conditionOutputs.length,
            BlockID: this.state.id,
        }, true);
    }
    trackBlockOutputConditionDeleted() {
        this.BuilderSegmentService.trackBlockOutputConditionDeleted({
            NumberConditions: this.state.$conditionOutputs.length,
            BlockID: this.state.id,
        }, true);
    }
    trackBlockOutputDefaultConditionEdited(newStateId, oldStateId) {
        this.BuilderSegmentService.trackBlockOutputDefaultConditionEdited({
            BlockID: this.state.id,
            NewStateID: newStateId,
            OldStateID: oldStateId,
        }, true);
    }
    trackBlockOutputConditionsPositionChanged() {
        this.BuilderSegmentService.trackBlockOutputConditionsPositionChanged({
            NumberConditions: this.state.$conditionOutputs.length,
            BlockID: this.state.id,
        }, true);
    }
    trackAllSelected() {
        this.BuilderSegmentService.trackAllSelectedActionsCheckboxes();
    }
    trackSelected() {
        this.BuilderSegmentService.trackSelectedActionCheckbox();
    }
    trackCopy() {
        this.BuilderSegmentService.trackCopySelectedAction();
    }
    changeInactivityOutputUndoRedoAction(newTarget, oldTarget, newTypeOfStateId, oldTypeOfStateId) {
        return new CardOutputContentIAction({
            data: {
                state: {
                    id: angular.copy(this.state.id),
                    $title: angular.copy(this.state.$title),
                },
                defaultOutput: oldTarget,
                newDefaultTarget: newTarget,
                newTypeOfStateId,
                oldTypeOfStateId,
            },
            execute: (data) => {
                const inactivityOutputIndex = this.state.$conditionOutputs.findIndex(co => co.$isAgentInactivityOutput);
                if (inactivityOutputIndex !== -1) {
                    this.state.$conditionOutputs[inactivityOutputIndex].typeOfStateId = data.newTypeOfStateId;
                    this.state.$conditionOutputs[inactivityOutputIndex].stateId = data.newDefaultTarget;
                    const currentState = angular.copy(this.state);
                    builderStore.setState({ ...currentState });
                }
            },
            undo: (data) => {
                const inactivityOutputIndex = this.state.$conditionOutputs.findIndex(co => co.$isAgentInactivityOutput);
                if (inactivityOutputIndex !== -1) {
                    this.state.$conditionOutputs[inactivityOutputIndex].typeOfStateId = data.oldTypeOfStateId;
                    this.state.$conditionOutputs[inactivityOutputIndex].stateId = data.defaultOutput;
                    const currentState = angular.copy(this.state);
                    builderStore.setState({ ...currentState });
                }
            },
        });
    }
    setDangerAttribute(elementId, dangerValue) {
        const targetElement = document.getElementById(elementId);
        targetElement?.setAttribute('danger', dangerValue.toString());
    }
    setErrorAttribute(elementId, errorMessage) {
        const targetElement = document.getElementById(elementId);
        targetElement?.setAttribute('error-message', errorMessage);
    }
};
//#endregion
AiOutputs.$inject = ['BuilderSegmentService', 'UndoRedoService', 'BlipToastService', 'clipboard', '$translate', 'AlertService', 'AgentSegmentService', '$timeout'];
AiOutputs = __decorate([
    Component({
        controllerAs: '$ctrl',
        template: view,
        bindings: {
            onAction: '&?',
            onOpenAiOutputEditModal: '&?',
            state: '=?',
            states: '=?',
            application: '<?',
            lock: '<',
        },
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof BuilderSegmentService !== "undefined" && BuilderSegmentService) === "function" ? _a : Object, typeof (_b = typeof UndoRedoService !== "undefined" && UndoRedoService) === "function" ? _b : Object, typeof (_c = typeof BlipToastService !== "undefined" && BlipToastService) === "function" ? _c : Object, Object, typeof (_e = typeof angular !== "undefined" && (_d = angular.translate) !== void 0 && _d.ITranslateService) === "function" ? _e : Object, typeof (_f = typeof AlertService !== "undefined" && AlertService) === "function" ? _f : Object, typeof (_g = typeof AgentSegmentService !== "undefined" && AgentSegmentService) === "function" ? _g : Object, typeof (_h = typeof angular !== "undefined" && angular.ITimeoutService) === "function" ? _h : Object])
], AiOutputs);
export { AiOutputs };
